export default "__VITE_ASSET__CnDCtFct__"